import { defineAction } from '~/prix'
import { z } from 'zod'
import animalProductionDeleteAction from './animalProductionDelete.action.json' with { type: 'json' }

const animalProductionDeleteDefinition = defineAction({
  ...animalProductionDeleteAction,
  input: z.object({
    id: z.string().uuid(),
  }),
  output: z.object({}),
})

export default animalProductionDeleteDefinition
